const nativeShare = () => typeof navigator.share === "function" && window.matchMedia("(hover: none), (max-width: 992px)").matches;

function initShare() {
	document.querySelectorAll("[data-share]").forEach((share) => {
		const toggle = share.querySelector("[aria-controls]");
		const panel = share.querySelector(`#${toggle?.getAttribute("aria-controls")}`);
		if (!toggle || !panel) return;

		const setOpen = (open) => {
			toggle.setAttribute("aria-expanded", String(open));
			panel.hidden = !open;
		};

		toggle.addEventListener("click", () => {
			if (nativeShare()) {
				navigator.share({ title: share.dataset.shareTitle, url: share.dataset.shareUrl }).catch(() => {});
				return;
			}
			setOpen(panel.hidden);
		});

		document.addEventListener("click", (event) => {
			if (!share.contains(event.target)) setOpen(false);
		});

		share.addEventListener("keydown", (event) => {
			if (event.key !== "Escape" || panel.hidden) return;
			setOpen(false);
			toggle.focus();
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initShare);
} else {
	initShare();
}
